// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabInternalTasksChecklist-moduleRequestProfileTabInternalTasksChecklist__llEDo";
var _2 = "RequestProfileTabInternalTasksChecklist-moduleitems__yXNH8";
export { _1 as "RequestProfileTabInternalTasksChecklist", _2 as "items" }
